import { Clock, Fuel, HelpCircle } from "lucide-react";
import { Container, Eyebrow, SectionTitle, IMG } from "./shared";

const PAINS = [
  { icon: Clock, title: "Hours lost to dead-end estimates", text: "Half your quote visits go to people who were just curious or had a budget that never matched the job." },
  { icon: Fuel, title: "Driving across the county for nothing", text: "Gas, traffic and a lost afternoon, only to find out the job is too small, too big or not what you do." },
  { icon: HelpCircle, title: "Walking in blind", text: "\"I need some work in the basement\" doesn't tell you what to bring, what to check or what to charge." },
];

export const Problem = () => (
  <section className="bg-slate-900 py-20 text-white sm:py-28" data-testid="landing-problem">
    <Container className="grid gap-12 lg:grid-cols-[1fr_1.2fr] lg:items-center">
      <div>
        <Eyebrow>The problem</Eyebrow>
        <h2 className="mt-4 font-display text-3xl font-extrabold leading-tight tracking-tight sm:text-4xl">
          Free estimates aren't free. They cost you your best hours.
        </h2>
        <img src={IMG.truck} alt="Contractor tools in a truck bed" className="mt-8 hidden h-64 w-full rounded-2xl object-cover opacity-90 lg:block" />
      </div>
      <div className="space-y-4">
        {PAINS.map(({ icon: Icon, title, text }) => (
          <div key={title} className="flex gap-4 rounded-2xl border border-white/10 bg-white/5 p-5">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[color-mix(in_srgb,var(--brand)_20%,transparent)] text-[color:var(--brand)]"><Icon className="h-5 w-5" /></span>
            <div>
              <p className="font-display text-lg font-bold">{title}</p>
              <p className="mt-1 text-[15px] leading-relaxed text-slate-300">{text}</p>
            </div>
          </div>
        ))}
      </div>
    </Container>
  </section>
);

export const SectionHeader = ({ eyebrow, title, sub }) => (
  <div className="max-w-2xl">
    <Eyebrow>{eyebrow}</Eyebrow>
    <SectionTitle className="mt-4">{title}</SectionTitle>
    {sub && <p className="mt-3 text-base text-slate-600 md:text-lg">{sub}</p>}
  </div>
);
